/******************************************************************************************
 *	Customer Renewal Quote Service
 ********************************************************************************************/
(function() {
  

  angular.module('rcServices.customerRenewalQuote', []).service(
    'CustomerRenewalQuote',
    /* @ngInject */
    function($q, DemoMode, jilResellerCustomers, MiniJil, User) {
      //Get a customer's renewal quote
      this.get = function(customerId) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.getCustomerQuote(customerId);
          if (data) {
            return $q.resolve(data);
          } else {
            return $q.reject({
              data: {},
              status: 404
            });
          }
        } else {
          return jilResellerCustomers.customerQuote.get({
            customerId,
            resellerId: User.getResellerID()
          }).$promise;
        }
      };
    }
  );
})();
